import axios from "axios";
import { getCSRFToken, fetchCSRFToken } from './csrf';

const BASE_API_URL = "/api/v1";

// Get all learning paths with optional filters
export const getLearningPaths = async (filters = {}) => {
    try {
        const params = {};

        if (filters.level) {
            params.level = filters.level;
        }

        if (filters.purpose) {
            params.purpose = filters.purpose;
        }

        if (filters.page) {
            params.page = filters.page;
        }

        console.log('Fetching learning paths with params:', params);

        const response = await axios.get(`${BASE_API_URL}/learning-paths/`, {
            params,
            withCredentials: true
        });

        console.log('Learning paths response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching learning paths:', error);
        throw error;
    }
};

// Get specific learning path by ID
export const getLearningPathById = async (id, filters = {}) => {
    try {
        const params = {};

        if (filters.level) {
            params.level = filters.level;
        }

        if (filters.purpose) {
            params.purpose = filters.purpose;
        }

        console.log(`Fetching learning path ${id} with params:`, params);

        const response = await axios.get(`${BASE_API_URL}/learning-paths/${id}/`, {
            params,
            withCredentials: true
        });

        console.log('Learning path response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error fetching learning path ${id}:`, error);
        throw error;
    }
};
